module.exports = __webpack_public_path__ + "img/resize-icon-tl.c2fedba0.svg";